import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ControlEquiposPage } from './control-equipos';


@NgModule({
  declarations: [
    ControlEquiposPage,
  ],
  imports: [
    IonicPageModule.forChild(ControlEquiposPage),
    //IonicSelectableModule
  ],
  exports: [ControlEquiposPage],
  entryComponents: [ControlEquiposPage]
})
export class ControlEquiposPageModule {}



// WEBPACK FOOTER //
// ./src/pages/control-equipos/control-equipos.module.ts